import { connect } from 'react-redux'
import { ToolBarComponent } from './ToolBarComponent'

const mapStateToProps = (state: any): any => {
	return {
	}
}

const mapDispatchToProps = {}

export const ToolBarContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ToolBarComponent)
